import AdultSymptomExercisePage from '@/components/AdultSymptomExercisePage';
import { isAdultExerciseGroup } from '@/lib/data/contentCatalog';
import { createFileRoute } from '@tanstack/react-router'
import ExerciseImage from "@/assets/exercise-background-photos/substance-use.jpg";
import substanceUseVideo1Mp4 from '@/assets/videos/adults-symptoms/substance-use/substance-use-part-1.mp4';
import substanceUseVideo1Webm from '@/assets/videos/adults-symptoms/substance-use/substance-use-part-1.webm';
import substanceUseVideo2Mp4 from '@/assets/videos/adults-symptoms/substance-use/substance-use-part-2.mp4';
import substanceUseVideo2Webm from '@/assets/videos/adults-symptoms/substance-use/substance-use-part-2.webm';
import substanceUsePoster from '@/assets/substance-use-poster.png';
import substanceUsePart1Ar from '/subs/substance-use-part-1.ar.vtt';
import substanceUsePart1En from '/subs/substance-use-part-1.en.vtt';
import substanceUsePart2Ar from '/subs/substance-use-part-2.ar.vtt';
import substanceUsePart2En from '/subs/substance-use-part-2.en.vtt';
import { useLocaleStore } from '@/lib/stores/localeStore';

export const Route = createFileRoute('/(content)/adults/exercises/substance-use/')({
   component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    group: isAdultExerciseGroup(search.group) ? search.group : undefined,
    mode: (search.mode === 'videos' || search.mode === 'exercises') ? search.mode as 'videos' | 'exercises' : undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Drugs, Alcohol and Cannabis Use - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "substance-use.title",
    navbar: {
      transparent: true,
      showTitle: false,
    },
  }),
});

function RouteComponent() {
  const { group, mode } = Route.useSearch();
  const navigate = Route.useNavigate();
  const locale = useLocaleStore((state) => state.locale);
  const captionsDir: 'ltr' | 'rtl' = locale === 'ar' ? 'rtl' : 'ltr';
  const videos = [
    {
      sources: [
        { src: substanceUseVideo1Webm, type: 'video/webm' },
        { src: substanceUseVideo1Mp4, type: 'video/mp4' },
      ],
      subtitleTracks: [
        { src: substanceUsePart1Ar, srcLang: 'ar', label: 'Arabic', default: true },
        { src: substanceUsePart1En, srcLang: 'en', label: 'English' },
      ],
      activeSubtitleLanguage: locale === 'ar' ? 'ar' : 'en',
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
    {
      sources: [
        { src: substanceUseVideo2Webm, type: 'video/webm' },
        { src: substanceUseVideo2Mp4, type: 'video/mp4' },
      ],
      subtitleTracks: [
        { src: substanceUsePart2Ar, srcLang: 'ar', label: 'Arabic', default: true },
        { src: substanceUsePart2En, srcLang: 'en', label: 'English' },
      ],
      activeSubtitleLanguage: locale === 'ar' ? 'ar' : 'en',
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
  ];

  return (
    <AdultSymptomExercisePage
      symptom="substance-use"
      titleKey="substance-use.title"
      heroImage={ExerciseImage}
      poster={substanceUsePoster}
      videos={videos}
      mode={mode}
      onModeChange={(nextMode) =>
        navigate({
          to: Route.to,
          search: {
            mode: nextMode ?? undefined,
            group: nextMode === 'exercises' ? group : undefined,
          },
        })
      }
      selectedGroup={group}
      onSelectGroup={(nextGroup) =>
        navigate({
          to: Route.to,
          search: { mode: 'exercises', group: nextGroup },
        })
      }
    />
  );
}
